import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as Rx from 'rxjs';
import { Seo } from './seo.service';

@Component({
  selector: 'fl-seo',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeoComponent implements OnInit, OnDestroy {
  private resetPageTagsSubscription?: Rx.Subscription;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private router: Router,
    private seo: Seo,
  ) {}

  ngOnInit() {
    this.resetPageTagsSubscription = this.router.events.subscribe(event => {
      // reset page tags to default values on navigation.
      if (event instanceof NavigationEnd) {
        this.seo.setDefaultPageTags();
        this.seo.removeAllStructuredData();
      }
    });
  }

  ngOnDestroy() {
    this.resetPageTagsSubscription?.unsubscribe();
  }
}
